import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IDeleteOfferFromFavoritesResponse200,
  type IDeleteOfferFromFavoritesResponse400,
  type TDeleteOfferFromFavoritesRequest,
  type TDeleteOfferFromFavoritesResponse_1,
  createDeleteOfferFromFavoritesModel,
  fetchDeleteOfferFromFavorites,
} from '@/repositories/generated/shared/favorites/v1/delete-offer-from-favorites';

export function fetchDeleteOfferFromFavoritesService(
  applicationContext: IQueryStateAppContext,
  parameters: TDeleteOfferFromFavoritesRequest,
): Promise<TDeleteOfferFromFavoritesResponse_1> {
  const { httpApi, logger } = applicationContext;

  const fetchAssertsService = new FetchAssertsService(
    createDeleteOfferFromFavoritesModel(parameters),
    '@/shared/store/serverSide/favorites/v1/delete-offer-from-favorites/internal/fetchService.ts',
    logger,
  );

  return fetchDeleteOfferFromFavorites<IDeleteOfferFromFavoritesResponse200, IDeleteOfferFromFavoritesResponse400>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
